import { QueryClientConfig, QueryFunction } from "react-query";
import request, { RequestOptions } from "./request";
import { Methods } from "./types";

const queryFn: QueryFunction = ({ queryKey }) => {
  const [url, data, options = {}] = queryKey;
  if (typeof url !== "string") {
    throw new Error("first item must be string");
  }
  const { method = Methods.POST } = options as RequestOptions;
  return request[method](url, data, {
    ...(options as RequestOptions),
    isUserQuery: true,
  });
};

const queryClientConfig: QueryClientConfig = {
  defaultOptions: {
    queries: {
      suspense: true,
      retry: false,
      queryFn,
    },
  },
};

export default queryClientConfig;
